// Email sign-ups without a page reload (footer Email + SUBSCRIBE, homepage
// TEAM P3 Email + JOIN).
//
// Each form's own validation script calls
//   window.P3Signup.submitting(form)
// right before it sends a valid email (form.requestSubmit()). This:
//   1. points the form at a hidden iframe, so the POST to Shopify (/contact,
//      customer form tagged "newsletter") happens in the background and the
//      page doesn't reload — Shopify's spam protection (hCaptcha) still runs
//      on the submission as normal;
//   2. instantly swaps the form's fields ([data-signup-fields]) for its
//      success message ([data-signup-success], "newsletter.success" in
//      locales/en.default.json);
//   3. if Shopify answers with its captcha challenge page instead (rare),
//      falls back to a normal full-page submission so the visitor can
//      complete it and the sign-up isn't lost.
// If this file doesn't load, the forms still work the old way (page reload).
(function () {
  var FRAME_NAME = 'p3-signup-frame';

  function getFrame() {
    var frame = document.querySelector('iframe[name="' + FRAME_NAME + '"]');
    if (!frame) {
      frame = document.createElement('iframe');
      frame.name = FRAME_NAME;
      frame.title = 'Email sign-up';
      frame.tabIndex = -1;
      frame.setAttribute('aria-hidden', 'true');
      frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
      document.body.appendChild(frame);
    }
    return frame;
  }

  function showSuccess(form) {
    var fields = form.querySelector('[data-signup-fields]');
    var success = form.querySelector('[data-signup-success]');
    if (!success) return;
    if (fields) fields.style.display = 'none';
    success.hidden = false;
    if (!success.hasAttribute('tabindex')) success.setAttribute('tabindex', '-1');
    try {
      success.focus({ preventScroll: true });
    } catch (e) {
      /* focus is a nicety only */
    }
  }

  function watchResponse(form, frame) {
    function onLoad() {
      frame.removeEventListener('load', onLoad);
      var href = '';
      try {
        href = frame.contentWindow.location.href;
      } catch (e) {
        /* not readable: leave it */
      }
      if (/\/challenge/.test(href)) {
        form.removeAttribute('target');
        form.submit();
      }
    }
    frame.addEventListener('load', onLoad);
  }

  window.P3Signup = {
    submitting: function (form) {
      if (!form || !form.querySelector('[data-signup-success]')) return;
      var frame = getFrame();
      form.setAttribute('target', FRAME_NAME);
      watchResponse(form, frame);
      showSuccess(form);
    },
  };
})();
